import { Box, styled, CircularProgress } from '@material-ui/core'
import ScanIcon from 'assets/icons/scan-bold.svg'
import { usePopup } from 'hooks/usePopup'
import { useState, useEffect } from 'react'
import BarcodeScannerComponent from 'react-qr-barcode-scanner'

import { TValue } from '../useScanner'

const position = 'initial !important'

interface IContainerCam {
  border: boolean
  loading: boolean | undefined
}

const ContainerCam = styled(Box)(({ border, loading }: IContainerCam) => ({
  width: '70%',
  maxWidth: '300px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 1,
  margin: '0 auto',
  '& > img': {
    position: 'absolute',
    width: '100%',
    height: '80%',
    padding: '1.5rem',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 3,
    filter:
      'invert(100%) sepia(1%) saturate(7388%) hue-rotate(162deg) brightness(121%) contrast(100%)',
  },
  '& video': {
    maxWidth: '100%',
    width: '100%',
    borderRadius: '10px',
    height: 'auto !important',
    position: position as any,
    margin: '0 auto',
    border: border ? `10px solid #89bd23` : 'none',
    opacity: loading ? 0.5 : 1,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    width: 'calc(100% - 2rem)',
    height: '6px',
    borderRadius: '4px',
    background: '#FFF',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 5,
    display: loading ? 'none' : 'block',
  },
}))

const LoadingOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 4,
  background: 'rgba(233, 229, 229, 0)',
})

const getCodeType = (format?: number): TValue => {
  const codeType =
    {
      5: 'data_matrix',
      11: 'qr_code',
    }[format as number] || 'bar_code'
  return codeType as TValue
}

const Cam = ({
  onSubmit,
  loading: externalLoading,
}: {
  onSubmit: (param: string, type: TValue) => void
  loading?: boolean
}) => {
  const [, setdisabledScanner] = useState(false)
  const [border, setBorder] = useState(false)
  const [isScannerActive, setIsScannerActive] = useState(true)
  const { addPopup } = usePopup()

  useEffect(() => {
    setIsScannerActive(!externalLoading)
  }, [externalLoading])

  const middleSubmit = (result: any) => {
    if (!result || !result?.text || externalLoading || !isScannerActive) return
    setdisabledScanner(state => {
      if (!state) {
        onSubmit(result?.text, getCodeType(result?.format))
        setBorder(true)
        navigator.vibrate(200)
        setTimeout(() => {
          setdisabledScanner(false)
          setBorder(false)
        }, 1000)
      }
      return true
    })
  }

  const onError = () => {
    addPopup({
      type: 'error',
      title: 'Erro ao ativar a camera do dispositivo',
    })
  }

  return (
    <ContainerCam border={border} loading={externalLoading}>
      <img src={ScanIcon} />
      {externalLoading ? (
        <LoadingOverlay>
          <CircularProgress style={{ color: '#89bd23', width: '40px', height: '40px' }} />
        </LoadingOverlay>
      ) : isScannerActive && (
        <BarcodeScannerComponent
          onError={onError}
          onUpdate={(_, result: any) => {
            if (result?.text) {
              middleSubmit(result)
            }
          }}
        />
      )}
    </ContainerCam>
  )
}

export default Cam
